import type { FeaturedLesson } from './FeaturedLessons'

const data: FeaturedLesson[] = [
  {
    url: `intro/how-to-think-about-analytics/`,
    title: `How to think about analytics`,
    description: `You need to think about analytics differently. In this lesson, you'll learn what a successful analytics process looks like and how to do it yourself.`,
    lessonNumber: 2,
    numberOfLessons: 7,
    courseTitle: `Intro to analytics`,
    courseNumber: 1,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/6Fx3NojxJI1VEIthRGnBrt/025dca566ed2f46b292203bd800e6034/icon-intro-to-analytics.svg`,
      title: `icon-intro-to-analytics`,
      width: 36,
      height: 36,
    },
  },
  {
    url: `collecting-data/naming-conventions-for-clean-data/`,
    title: `Naming Conventions: Why You Need Them for Clean Data`,
    description: `To speed up your time to insight, you should enforce a naming convention when instrumenting analytics. In this lesson, we’ll go over why you need a naming standard and our preferred approach, the object-action framework.`,
    lessonNumber: 4,
    numberOfLessons: 8,
    courseTitle: `Collecting the right data`,
    courseNumber: 2,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/1Mr3RAmaaIWeqJRXuK5wba/8fe2402752c0f9989fe00a6c651babb3/icon-collecting-the-right-data.svg`,
      title: `icon-collecting-the-right-data`,
      width: 36,
      height: 36,
    },
  },
  {
    url: `choosing-stack/how-to-choose-the-best-performance-monitoring-tool/`,
    title: `9 Best Application Performance Monitoring Tools Compared`,
    description: `Performance issues destroy your customer experience. So stop them in their tracks! This lesson will give you insight into the performance monitoring vendor landscape and walk through some key considerations when it comes to selecting the right tool for your business.`,
    lessonNumber: 3,
    numberOfLessons: 7,
    courseTitle: `Choosing the right stack`,
    courseNumber: 3,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/5v3NWA2GrFvgHBVbfTNlFV/636280452d1140c53f9f88c79141253e/icon-choosing-the-right-stack.svg`,
      title: `icon-choosing-the-right-stack`,
      width: 36,
      height: 36,
    },
  },
  {
    url: `building-data-driven-company/7-launch-day-data-mistakes-to-avoid/`,
    title: `7 launch day data mistakes to avoid`,
    description: `Launch day only comes around so often. So when it does, you want to make sure your using data to get the most out of this opportunity. Over the years, we've launched countless products and features, and have worked with some of the biggest companies advising them on data strategies for new launches. This chapter outlines some of the most common data pitfalls we've seen heading into launch day, and some easy strategies to avoid them.`,
    lessonNumber: 1,
    numberOfLessons: 5,
    courseTitle: `Building a data driven company`,
    courseNumber: 4,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/2wGkv2gxl5lO64bgXXrUjE/095a5b1b43d3530393e38f66a00b6017/icon-bulding-a-data-driven-company.svg`,
      title: `icon-bulding-a-data-driven-company`,
      width: 36,
      height: 36,
    },
  },
  {
    url: `grow-using-data/how-to-create-the-best-audiences-for-your-campaigns/`,
    title: `How to create the best audiences for your campaigns`,
    description: `Getting the right message to the right person at the right time requires that your tools are working off the right audiences. While 1:1 communication may be out of the question as you scale, it doesn’t mean you can’t engage users and personal and relevant ways. Check out this lesson to learn more about the audiences every B2C and B2B company can use to guarantee high engagement.`,
    lessonNumber: 3,
    numberOfLessons: 7,
    courseTitle: `Grow using data`,
    courseNumber: 5,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/5Z2jI1UWnReSDpfkXH8qib/bc7129766fc9ce50a8d9ffdcd2291c8c/icon-grow-using-data.svg`,
      title: `icon-grow-using-data`,
      width: 36,
      height: 36,
    },
  },
  {
    url: `advanced-analytics/take-your-product-usability-to-the-next-level/`,
    title: `Product Usability: How to Measure and Improve it`,
    description: `In this lesson, you'll learn how to understand your product usability metrics to better enhance adoption and engagement in your product.`,
    lessonNumber: 2,
    numberOfLessons: 2,
    courseTitle: `Advanced analytics`,
    courseNumber: 6,
    courseIcon: {
      src: `//images.ctfassets.net/h6ufgtwb6nv1/1BUgGyYXMEMYlKk3dqBch0/e342a73afe75acd4fc6aaa5f80457432/icon-advance-analytics.svg`,
      title: `icon-advance-analytics`,
      width: 36,
      height: 36,
    },
  },
]

export default data
